var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass,style:([_vm.style, _vm.customStyle]),attrs:{"title":_vm.avatarAlt}},[(!this.src)?_c('span',[_vm._v(_vm._s(_vm.userInitial))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }